const c = {
  "roche-back-to-branch": "roche-back-to-branch",
  "roche-back-to-branch__content": "roche-back-to-branch__content"
};
export {
  c as default
};
